import AddToCartFormik from '@jetshop/core/components/Mutation/AddToCartFormik';
// import ProductConfigurationContext
//   from '@jetshop/core/components/ProductConfigurationProvider/ProductConfigurationContext';
// import {useDynamicPrice} from '@jetshop/core/hooks/useDynamicPrice';
import t from '@jetshop/intl';
// import {SelectDropdown} from '@jetshop/ui/Select';
// import {TopListItem} from '@jetshop/ui/Select/SelectDropdown';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import { Form } from 'formik';
import React, { useContext } from 'react';
import styled from 'react-emotion';
import { toast } from 'react-toastify';
import addToCartMutation from '../../Cart/addToCart.gql';
import CartQuery from '../../Cart/CartQuery.gql';
import InputWithLabel, {
  ErrorSpan as ErrorWrap,
  Label
} from '../../Forms/Input';
import Button from '../../ui/Button';
import { useProductValidationMessage } from '../useProductValidationMessage';
import { VariantSelector } from '../VariantSelector';
import ProductToastWrapper from './ProductToast';
import StockStatusIndicator from '../StockStatus/StockStatusIndicator';
import NotifyWhenBack from '../StockStatus/NotifyWhenBack';

// const PickerWrapper = styled('div')`
//   width: 100%;
//   position: relative;
//   ${TopListItem} {
//     border-radius: 4px;
//   }
// `;

// const DefaultWrapper = styled(PickerWrapper)`
//   button {
//     height: 48px !important;
//   }
// `;

// const ErrorSpan = styled(ErrorWrap)`
//   bottom: 0;
// `;

const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  ${({ theme }) => theme.below.md} {
    align-items: center;
  }
`;

const QuantityAddToCartWrapper = styled('div')`
  margin-top: 16px;
  display: flex;
  width: 100%;
  align-items: center;
`;

const AddToCartButton = styled(Button)`
  background: ${({ theme }) => theme.colors.pink};
  height: ${({ theme }) => theme.sizes.prodElementHeight};
  color: ${({ theme }) => theme.colors.black};
  max-width: 288px;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  transition: all ease-in-out 0.2s;
  &:hover {
    background: ${({ theme }) => theme.colors.pinkDark};
    color: #fff;
  }
`;

// const DefaultPicker = ({option, error, ...props}) => (
//   <DefaultWrapper>
//     <Label for={`${option.name}-select-dropdown`}>{option.name}</Label>
//     <SelectDropdown
//       {...props}
//       id={`${option.name}-select-dropdown`}
//       data-testid={`${option.name}-select-dropdown`}
//     />
//     {error && <ErrorSpan>{error}</ErrorSpan>}
//   </DefaultWrapper>
// );

function AddToCartForm({
  product,
  variant,
  getMissingOptions,
  variantHandler
}) {
  // const configurationContext = useContext(ProductConfigurationContext);
  // const price = useDynamicPrice(product, variant);
  const stockStatus = useStockStatus(variant || product);
  const outOfStockNotify = stockStatus.status === 'notifyWhenBack';
  const { variantValidation, missingOptions } = variantHandler;
  const { hasVariants } = product;
  const { validationMessage, enableValidation } = useProductValidationMessage({
    missingOptions,
    variantValidation,
    hasVariants,
    stockStatus
  });

  const onAddToCartInit = ({ mutationId, quantity, price }) => {
    toast(
      <ProductToastWrapper
        selectedVariation={variant}
        product={product}
        quantity={quantity}
        price={price}
      />,
      {
        autoClose: 2000,
        toastId: mutationId
      }
    );
  };
  const onAddToCartError = () => {
    return ({ selectedVariation, mutationId, quantity, price, error }) => {
      toast.dismiss(mutationId);
      toast(
        <ProductToastWrapper
          selectedVariation={selectedVariation}
          product={product}
          quantity={quantity}
          price={price}
          error={error}
        />,
        {
          autoClose: 5000,
          toastId: `${mutationId}--error`
        }
      );
    };
  };
  return (
    <AddToCartFormik
      onAddToCartInit={onAddToCartInit}
      onAddToCartError={onAddToCartError}
      cartQuery={CartQuery}
      cartMutation={addToCartMutation}
      product={product}
      variant={variant}
      getMissingOptions={getMissingOptions}
    >
      {() => {
        return (
          <>
            {product.hasVariants && (
              <VariantSelector
                product={product}
                variantHandler={variantHandler}
                showValidation={!!validationMessage}
              />
            )}
            <StyledForm>
              {!outOfStockNotify && (
                <QuantityAddToCartWrapper>
                  <InputWithLabel
                    disableValidation
                    wrapperClassName="quantity-input-wrapper"
                    min="1"
                    type="number"
                    name="quantity"
                    label="Quantity"
                  />
                  <AddToCartButton
                    data-testid="add-to-cart"
                    type="submit"
                    disabled={!!validationMessage}
                    onClick={enableValidation}
                    style={{
                      opacity: !!validationMessage ? 0.7 : 1,
                      cursor: !!validationMessage ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {validationMessage ? validationMessage : t('Add to cart')}
                  </AddToCartButton>
                  <StockStatusIndicator
                    status={stockStatus.status}
                    text={stockStatus.text}
                  />
                </QuantityAddToCartWrapper>
              )}
            </StyledForm>
            {outOfStockNotify && (
              <NotifyWhenBack
                text={stockStatus.text}
                articleNumber={(variant || product).articleNumber}
              />
            )}
          </>
        );
      }}
    </AddToCartFormik>
  );
}

export default AddToCartForm;
